import React from 'react';
const badgeClass = 'flex h-8 items-center justify-center rounded-md border border-slate-200 bg-white px-3 text-xs font-bold shadow-sm';
export function PaymentLogos() {
  return <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-1">
      <span className={`${badgeClass} tracking-wide text-[#1a1f71]`} data-id="element-2">VISA</span>
      <span className={`${badgeClass} gap-1`} data-id="element-3">
        <span className="h-4 w-4 rounded-full bg-[#eb001b]" data-id="element-4" />
        <span className="-ml-2 h-4 w-4 rounded-full bg-[#f79e1b]/90" data-id="element-5" />
        <span className="ml-1 text-slate-700" data-id="element-6">Mastercard</span>
      </span>
      <span className={`${badgeClass} text-[#2e77bc]`} data-id="element-7">AMEX</span>
      <span className={`${badgeClass}`} data-id="element-8">
        <span className="text-[#003087]" data-id="element-9">Pay</span>
        <span className="text-[#009cde]" data-id="element-10">Pal</span>
      </span>
      <span className={`${badgeClass} text-[#5a31f4]`} data-id="element-11">Shopify</span>
    </div>;
}